import React, { Component } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { Modal, Button, Form, Message } from 'semantic-ui-react';

const propTypes = {
  // State
  group: PropTypes.shape({
    name: PropTypes.string.isRequired,
    _id: PropTypes.string,
  }).isRequired,
  isNew: PropTypes.bool.isRequired,
  tagGroups: PropTypes.arrayOf(PropTypes.shape()).isRequired,

  // Dispatch
  addGroup: PropTypes.func.isRequired,
  updateGroup: PropTypes.func.isRequired,
  closeGroupEditor: PropTypes.func.isRequired,
  deleteGroup: PropTypes.func.isRequired,
};

/* eslint react/prefer-stateless-function: "off" */
class TagModal extends Component {
  constructor(props) {
    super(props);
    this.errorText = this.errorText.bind(this);
  }

  componentWillMount() {
    this.resetComponent();
    const { group } = this.props;
    if (group) {
      this.setState({
        group: group.name,
      });
    }
  }

  resetComponent() {
    return this.setState({
      group: '',
      updatePosting: false,
      deletePosting: false,
    });
  }

  deleteGroup() {
    this.setState({
      deletePosting: true,
    });
    const data = {
      _id: this.props.group._id,
    };
    axios.post('/api/tag-groups/delete-one', data)
      .then(() => {
        this.props.deleteGroup(data._id);
        this.resetComponent();
        this.props.closeGroupEditor();
      })
      .catch((err) => {
        console.log('error', err);
        this.setState({
          deletePosting: false,
        });
      });
  }

  updateGroup() {
    this.setState({
      updatePosting: true,
    });
    const data = {
      name: this.state.group,
    };
    if (this.props.group && this.props.group._id) data._id = this.props.group._id;
    axios.post(`/api/tag-groups/${this.props.isNew ? 'insert-one' : 'update-one'}`, data)
      .then((response) => {
        const group = {
          ...data,
          _id: this.props.isNew ? response.data.insertedId : this.props.group._id,
        };
        if (this.props.isNew) this.props.addGroup(group);
        else this.props.updateGroup(group);
        this.resetComponent();
        this.props.closeGroupEditor();
      })
      .catch((err) => {
        console.log('error', err);
        this.setState({
          updatePosting: false,
        });
      });
  }

  errorText() {
    const { tagGroups } = this.props;
    const initialTagGroup = this.props.group.name;
    const currentTagGroup = this.state.group;

    const errors = [];
    if (initialTagGroup === currentTagGroup) return undefined;
    if (currentTagGroup === undefined || currentTagGroup.length === 0) {
      errors.push(<li key={`group-${currentTagGroup}-missing-group`}>Missing: Tag Group</li>);
    } else if (currentTagGroup === undefined
      || tagGroups.map(g => g.name.toLowerCase()).includes(currentTagGroup.toLowerCase())) {
      errors.push(<li key={`${currentTagGroup}-already-exists`}>Tag Group by this name already exists</li>);
    }
    if (errors.length === 0) return undefined;
    return <ul>{errors}</ul>;
  }

  render() {
    const { isNew, closeGroupEditor, group } = this.props;
    const initialTagGroup = this.props.group.name;
    const currentTagGroup = this.state.group;
    const errorText = this.errorText();

    return (
      <Modal
        open
        closeOnEscape={false}
        closeOnDimmerClick={false}
      >
        <Modal.Header>Edit Group: {initialTagGroup}</Modal.Header>
        <Modal.Content>
          <Form>
            <Form.Group widths="equal">
              <Form.Input
                fluid
                label="Tag Group"
                id="tagGroup"
                value={currentTagGroup}
                onChange={(event, data) => {
                  this.setState({
                    group: data.value,
                  });
                }}
              />
            </Form.Group>
          </Form>
          {errorText ? <Message error header="Errors:" content={errorText} /> : null}
        </Modal.Content>
        <Modal.Actions>
          <Button
            floated="left"
            basic
            loading={this.state.deletePosting}
            color="red"
            content="Delete Group"
            icon="trash"
            labelPosition="left"
            disabled={!group.tags || group.tags.length > 0}
            onClick={() => {
              this.deleteGroup();
            }}
          />
          <Button
            content="Cancel"
            icon="cancel"
            labelPosition="right"
            onClick={() => {
              closeGroupEditor();
              this.resetComponent();
            }}
          />
          <Button
            primary
            loading={this.state.updatePosting}
            content={isNew ? 'Create' : 'Update'}
            icon="save"
            labelPosition="right"
            onClick={() => {
              this.updateGroup();
            }}
            disabled={!currentTagGroup || !!errorText}
          />
        </Modal.Actions>
      </Modal>
    );
  }
}

TagModal.propTypes = propTypes;
export default TagModal;



// WEBPACK FOOTER //
// ./src/components/GroupEditor.jsx